import { create } from "zustand";

type Theme = "light" | "dark";

const THEME_KEY = "sante-admin-theme";

const readInitialTheme = (): Theme => {
  if (typeof window === "undefined") return "dark";
  const stored = window.localStorage.getItem(THEME_KEY);
  if (stored === "light" || stored === "dark") return stored;
  return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
};

const applyTheme = (theme: Theme) => {
  const root = document.documentElement;
  root.classList.toggle("dark", theme === "dark");
  root.classList.toggle("light", theme === "light");
  document.body.dataset.theme = theme;
  window.localStorage.setItem(THEME_KEY, theme);
};

interface UiState {
  theme: Theme;
  paletteOpen: boolean;
  sidebarCollapsed: boolean;
  initTheme: () => void;
  toggleTheme: () => void;
  openPalette: () => void;
  closePalette: () => void;
  togglePalette: () => void;
  toggleSidebar: () => void;
}

export const useUi = create<UiState>((set, get) => ({
  theme: readInitialTheme(),
  paletteOpen: false,
  sidebarCollapsed: false,
  initTheme: () => applyTheme(get().theme),
  toggleTheme: () =>
    set((s) => {
      const theme: Theme = s.theme === "dark" ? "light" : "dark";
      applyTheme(theme);
      return { theme };
    }),
  openPalette: () => set({ paletteOpen: true }),
  closePalette: () => set({ paletteOpen: false }),
  togglePalette: () => set((s) => ({ paletteOpen: !s.paletteOpen })),
  toggleSidebar: () => set((s) => ({ sidebarCollapsed: !s.sidebarCollapsed })),
}));
